import React, {lazy, Suspense} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {ROUTES} from '../db/models/const';
import NotFound from '../pages/NotFound/main';
import {CallRequest} from '../pages/Signup/CallRequest/main';
import SignupStudentCompanyLocked from '../pages/Signup/student/CompanyBounded/main';
import UserPrivate from '../pages/UserPrivate/main';
import {PrivateRoute} from './private';
import {PublicRoute} from './public';
const CiaoAnsia = lazy(() => import('../pages/CiaoAnsia/main'));
const EmojiDiscover = lazy(() => import('../pages/EmojiDiscover/main'));
const CookiePolicy = lazy(() => import('../components/Privacy/CookiePolicy'));
const PrivacyPolicy = lazy(() => import('../components/Privacy/PrivacyPolicy'));
const Terms = lazy(() => import('../components/Privacy/Terms'));
const PublicRm = lazy(() => import('../pages/PublicRm/main'));
const ManageAccount = lazy(() => import('../pages/ManageAccount/main'));
const Curriculum = lazy(() => import('../pages/Curriculum/main'));
const Login = lazy(() => import('../pages/Login/main'));
const SignupStudent = lazy(() => import('../pages/Signup/student/main'));
const SignupStudentSchool = lazy(() => import('../pages/Signup/student/School/main'));
const ToolbarPublic = lazy(() => import('../components/ToolbarPublic/main'));
const Toolbar = lazy(() => import('../components/Toolbar/main'));
const Test = lazy(() => import('../pages/Test/main'));

export const Routes = ({topRef}) => {
    return (
        <Switch>
            <Route path="/terms" exact>
                <Suspense fallback={<div>Loading...</div>}>
                    <ToolbarPublic/>
                    <Terms/>
                </Suspense>
            </Route>
            <Route path="/cookie" exact>
                <Suspense fallback={<div>Loading...</div>}>
                    <ToolbarPublic/>
                    <CookiePolicy/>
                </Suspense>
            </Route>
            <Route path="/privacy" exact>
                <Suspense fallback={<div>Loading...</div>}>
                    <ToolbarPublic/>
                    <PrivacyPolicy/>
                </Suspense>
            </Route>

            <Route path="/laurea" exact>
                <Suspense fallback={<div>Loading...</div>}>
                    <ToolbarPublic/>
                    <CiaoAnsia/>
                </Suspense>
            </Route>

            <Route path={ROUTES.EMOJI}>
                <Suspense fallback={<div>Loading...</div>}>
                    <ToolbarPublic/>
                    <EmojiDiscover topRef={topRef}/>
                </Suspense>
            </Route>

            <Route path="/auth/action" exact>
                <Suspense fallback={<div>Loading...</div>}>
                    <ToolbarPublic/>
                    <ManageAccount/>
                </Suspense>
            </Route>

            <Route path="/test">
                <Suspense fallback={<div>Loading...</div>}>
                    <Toolbar />
                    <Test />
                </Suspense>
            </Route>

            <Route path="/curriculum">
                <Suspense fallback={<div>Loading...</div>}>
                    <ToolbarPublic/>
                    <Curriculum/>
                </Suspense>
            </Route>

            <PublicRoute path={ROUTES.LOGIN}>
                <Suspense fallback={<div>Loading...</div>}>
                    <ToolbarPublic/>
                    <Login topRef={topRef}></Login>
                </Suspense>
            </PublicRoute>

            <PublicRoute path={ROUTES.SIGNUP_STUDENT} exact>
                <Suspense fallback={<div>Loading...</div>}>
                    <ToolbarPublic/>
                    <SignupStudent/>
                </Suspense>
            </PublicRoute>

            <PublicRoute path={ROUTES.SIGNUP_STUDENT_SCHOOL} exact>
                <Suspense fallback={<div>Loading...</div>}>
                    <ToolbarPublic/>
                    <SignupStudentSchool/>
                </Suspense>
            </PublicRoute>

            <PublicRoute path={ROUTES.SIGNUP_STUDENT_COMPANY_BOUNDED} exact>
                <Suspense fallback={<div>Loading...</div>}>
                    <ToolbarPublic/>
                    <SignupStudentCompanyLocked/>
                </Suspense>
            </PublicRoute>

            <PublicRoute path={ROUTES.SIGNUP_COMPANY} exact>
                <Suspense fallback={<div>Loading...</div>}>
                    <ToolbarPublic/>
                    <CallRequest topRef={topRef}></CallRequest>
                </Suspense>
            </PublicRoute>

            <PublicRoute path="/public/rm/:rmId" exact>
                <Suspense fallback={<div>Loading...</div>}>
                    <ToolbarPublic/>
                    <PublicRm topRef={topRef}></PublicRm>
                </Suspense>
            </PublicRoute>

            <PrivateRoute path={ROUTES.ME}>
                <Suspense fallback={<div>Loading...</div>}>
                    <UserPrivate topRef={topRef}/>
                </Suspense>
            </PrivateRoute>

            <PublicRoute path="/" exact>
                <Redirect to={ROUTES.LOGIN}/>
            </PublicRoute>

            <Route path={ROUTES.NOT_FOUND}>
                <Suspense fallback={<div>Loading...</div>}>
                    <Toolbar/>
                    <NotFound/>
                </Suspense>
            </Route>

            <Redirect to={ROUTES.NOT_FOUND}/>
        </Switch>
    )
}
